import routes from './routes';
import { SetRoutes } from 'components';

const ManagerMainPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ManagerMainPage;
